export const CAREERS_PAGE = {
    hero: {
        tag: "Careers",
        headline: `Build the future of <br /><span class="text-aiblue">learning in India</span> with us.`,
        description:
            "We're hiring high-performance sales talent across enterprise and consumer. Join a founding team that's not just building software — we're rebuilding how a country learns.",
    },
    whySection: {
        tag: "Why AI.Prof",
        heading: "Why Join AI.Prof ?",
        perks: [
            {
                label: "Uncapped Earning Potential",
                detail: "Highly lucrative, performance-linked incentive models that reward top closing talent.",
            },
            {
                label: "Shape the Frontier of Learning",
                detail: "Work directly with a bleeding-edge platform that is actively replacing broken, outdated models of education across multiple institutional landscapes.",
            },
            {
                label: "Fast-Tracked Internal Growth",
                detail: "As an early-stage, hyper-scaling ecosystem backed by industry-disrupting founders, your career trajectory here is entirely limited only by your execution.",
            },
            {
                label: "Premium Toolkits",
                detail: "Access to modern data stacks, CRMs, and streamlined workflows designed to help you spend your time closing, not doing busywork.",
            },
        ],
    },
    openApplication: {
        heading: "Don't see your role?",
        description: "Write to",
        email: "support@aiprof.com",
    },
    applyFormUrl: "https://forms.gle/4dcvTpzxPN28xdsT7",
    roles: [
        {
            title: "Regional Head – Institutional Partnerships",
            team: "B2B Sales",
            badge: "Leadership",
            location: "Hyderabad / Regional Travel",
            type: "Full-time",
            experience: "4–7 years",
            brief: "You will be the face of AI.Prof to institutional owners, directors, C-suite executives, and leadership boards. Your primary goal is to secure high-ticket, multi-year contracts that integrate the AI.Prof ecosystem into educational institutions and organizational frameworks.",
            roleDescription:
                "As the Sales Lead (B2B), you are a high-performing enterprise sales professional who thrives on navigating complex organizational hierarchies. You will own the B2B revenue targets for your region, driving the deployment of AI.Prof's native learning OS across diverse institutional clients. You will manage a high-octane team of business development managers, build long-term strategic pipelines, and fundamentally redefine how organizations approach skill development.",
            responsibilities: [
                {
                    title: "End-to-End Enterprise Sales",
                    detail: "Own the entire institutional sales cycle from high-level prospecting and cold entry to negotiating and closing high-value, multi-year contracts with organization management.",
                },
                {
                    title: "Executive Stakeholder Management",
                    detail: "Build and nurture trusted relationships with key decision-makers, including institutional heads, trustees, directors, company executives, and board members.",
                },
                {
                    title: "Strategic Territory Planning",
                    detail: "Develop and execute a robust regional sales strategy. Forecast revenue accurately and maintain a highly visible pipeline using modern CRM systems.",
                },
                {
                    title: "Value-Based Product Evangelism",
                    detail: "Conduct high-impact platform demonstrations for institutional leadership, illustrating how AI.Prof Platform directly improves organizational outcomes and baseline metrics.",
                },
                {
                    title: "Team Leadership & Mentorship",
                    detail: "Lead, mentor, and scale the team. Establish clear performance KPIs, conduct pipeline reviews, and remove roadblocks to ensure the team consistently hits its goals.",
                },
                {
                    title: "Market Feedback Loop",
                    detail: "Act as a critical bridge between institutional clients and our internal product/curriculum teams, relaying real-world requirements regarding pricing structures, deployment friction, and market demands.",
                },
            ],
            qualifications: [
                "4 to 7 years of core B2B, enterprise, or institutional sales experience (prior experience in high-growth EdTech SaaS, corporate training acquisition, or institutional partnerships is highly valued).",
                "A documented track record of consistently meeting or exceeding aggressive enterprise sales quotas.",
                "Strong executive presence with the ability to confidently present to and negotiate with senior business and organizational leaders.",
                "High commercial acumen to structure complex financial deals, net-fee sharing agreements, and articulate tangible business ROI to buyers.",
                "Exceptional communication and presentation skills, with a native ability to simplify technical concepts.",
                "Willingness to travel extensively across the designated region to close strategic deals on-site.",
                "Fluency in English along with one regional language (preferably Telugu or Hindi) to optimize consumer resonance across different demographics.",
            ],
        },
        {
            title: "Business Development Manager – Institutional Partnerships",
            team: "B2B Sales",
            badge: "Individual Contributor",
            location: "Hyderabad / Bengaluru",
            type: "Full-time",
            experience: "2–4 years",
            brief: "You are the primary engine driving our B2B lead generation pipeline. You will identify target institutions and organizations, secure meetings with top-level decision-makers, deliver compelling product demos, and assist senior leads in closing enterprise deals.",
            roleDescription:
                "We are looking for a hungry, consultative B2B sales professional who knows how to open doors. As an Assistant Sales Lead, you will map out institutional landscapes, establish initial contact with leadership teams, and ensure that AI.Prof is a frequent topic of conversation in executive boardrooms.",
            responsibilities: [
                {
                    title: "Prospecting & Market Mapping",
                    detail: "Actively research and map potential partner institutions, schools, training ecosystems, and corporate clients in your assigned territory.",
                },
                {
                    title: "Lead Generation & Cold Outreach",
                    detail: "Bypass gatekeepers using smart multi-channel outreach (cold calling, LinkedIn, email campaigns, networking) to secure initial discovery meetings with key organizational stakeholders.",
                },
                {
                    title: "Consultative Pitching",
                    detail: "Lead initial exploratory calls and deliver flawless platform demonstrations, articulating how AI.Prof solves critical engagement, evaluation, and deployment challenges.",
                },
                {
                    title: "Deal Support & Documentation",
                    detail: "Collaborate closely with the management to prepare tailored commercial proposals, custom deployment blueprints, and memorandum documents (MoUs).",
                },
                {
                    title: "CRM Discipline",
                    detail: "Maintain absolute data integrity across our CRM, tracking every touchpoint, follow-up task, and pipeline stage to optimize sales forecasting.",
                },
            ],
            qualifications: [
                "2 to 4 years of proven experience in B2B corporate sales, inside enterprise sales, or business development roles.",
                "A \u201chunter\u201d mentality with a relentless drive to follow up and turn cold accounts into active prospects.",
                "Quick technical adaptability\u2014ability to understand our AI-driven capabilities and demo them fluidly to non-technical buyers.",
                "Excellent organizational and time-management skills.",
                "A highly collaborative spirit, ready to work seamlessly within a fast-moving, target-driven B2B team.",
                "Fluency in English along with one regional language (preferably Telugu or Hindi) to optimize consumer resonance across different demographics.",
            ],
        },
        {
            title: "Growth Lead – Direct to Consumer",
            team: "B2C Sales",
            badge: "Leadership",
            location: "Hyderabad",
            type: "Full-time",
            experience: "4–7 years",
            brief: "You will lead our direct-to-consumer sales machine. You will manage a large team of counselors and inside sales executives, optimize the consumer conversion funnel, and scale revenue generated from individual learners, students, and parents.",
            roleDescription:
                "As the Sales Lead (B2C), you are a metric-driven inside sales powerhouse. You will be responsible for scaling individual consumer enrollments into AI.Prof\u2019s direct training cohorts, premium tracks, and independent placement packages. You will design sales strategies, run high-velocity call flows, and coach the sales team to peak performance.",
            responsibilities: [
                {
                    title: "Revenue & Funnel Ownership",
                    detail: "Take complete accountability for monthly, quarterly, and annual B2C revenue targets, successfully driving enrollments across both high-velocity inside sales channels and mass events.",
                },
                {
                    title: "Mass Presentations & Evangelism",
                    detail: "Personally deliver engaging, high-impact presentations (auditoriums, mega-webinars, and large group seminars) to prospective students and parents simultaneously, spark top-of-funnel interest.",
                },
                {
                    title: "Bulk-to-Individual Funnel Design",
                    detail: "Design the operational process workflow (such as setting up localized QR lead-capture methods or immediate post-event routing templates) that allows a student to smoothly register for a program.",
                },
                {
                    title: "Team Leadership & Floor Management",
                    detail: "Hire, train, and manage a team of inside sales counselors and Assistant Leads. Conduct daily stand-ups, run live call listening/coaching modules, and assign post-presentation breakout groups to capture high-intent leads.",
                },
                {
                    title: "Funnel Optimization & Analytics",
                    detail: "Deeply analyze conversion metrics from initial lead capture to final payment. Pinpoint drop-off points, refine call and event scripts, and optimize follow-up playbooks to eliminate pipeline leakage.",
                },
                {
                    title: "High-Value Closing",
                    detail: "Step onto the floor to close complex or hesitant parents/learners by clearly articulating the ROI of our ecosystem.",
                },
            ],
            qualifications: [
                "4 to 7 years of high-velocity B2C inside sales or telesales experience, with a minimum of 2 years actively managing a sales team (prior EdTech or direct consumer-tech experience is a massive asset).",
                "Complete fluency in consumer sales metrics (Lead Velocity, Connect Rates, Call-to-Close ratios, CAC).",
                "Outstanding coaching skills\u2014the ability to break down a recorded call and provide actionable behavioral feedback to an agent.",
                "High energy, structural resilience, and a proven ability to perform smoothly in high-pressure environments.",
                "Empathetic yet incredibly persuasive communication style.",
                "Fluency in English along with Telugu to optimize consumer resonance across different demographics.",
            ],
        },
        {
            title: "Assistant Sales Lead – Direct to Consumer",
            team: "B2C Sales",
            badge: "Individual Contributor",
            location: "Hyderabad",
            type: "Full-time",
            experience: "2–4 years",
            brief: "You are the vital direct link between AI.Prof and our individual consumers. Through high-volume, consultative phone conversations, you will guide students, parents, and learners through our value proposition and securely close direct enrollments.",
            roleDescription:
                "We are looking for self-motivated, high-energy consumer sales professionals. As an Assistant Sales Lead (B2C), you will deal directly with individual consumers, unpack their career aspirations or academic anxieties, and confidently position AI.Prof\u2019s ecosystem as the single best vehicle for their future.",
            responsibilities: [
                {
                    title: "Consultative Outbound Sales",
                    detail: "Conduct high-volume outbound calling cycles to warm and hot inbound leads. Actively engage with students and parents to diagnose their career anxieties.",
                },
                {
                    title: "Presentation Execution",
                    detail: "Deliver dynamic, high-energy group presentations, classroom seminars, or cohort pitches to student audiences to create immediate brand awareness and drive inbound inquiries.",
                },
                {
                    title: "Individual Conversion",
                    detail: "On-board students instantly following presentations by executing on-ground lead capture protocols.",
                },
                {
                    title: "Target Achievement",
                    detail: "Relentlessly pursue and exceed individual daily, weekly, and monthly enrollment quotas by effectively balancing direct inside sales follow-ups with mass presentation pipelines.",
                },
                {
                    title: "Pipeline Management & CRM Hygiene",
                    detail: "Maintain absolute data integrity within the CRM, meticulously tracking student profiles, update statuses, callback timelines, and conversion stages.",
                },
                {
                    title: "Peer Support & Event Anchoring",
                    detail: "Assist the Growth Lead in anchoring large-scale events, managing enrollment breakout desks, and sharing successful objection-handling strategies with junior team members.",
                },
            ],
            qualifications: [
                "2 to 4 years of solid experience in direct consumer inside sales, telesales, or high-volume consultative counseling.",
                "A strong, verifiable history of hitting individual monthly targets.",
                "Exceptional active listening skills with the ability to build high-trust relationships quickly over a call.",
                "High resilience and grit\u2014the capacity to treat every new call with fresh enthusiasm, regardless of previous rejections.",
                "Fluency in English along with Telugu to optimize consumer resonance across different demographics.",
            ],
        },
    ],
};
